import { useQuery } from "@tanstack/react-query";
export const createContestsEditionSurveysQueries = (requests, _queryClient) => ({
    useSurveyLinks: (params, options = {}) => useQuery({
        queryKey: ["contests-edition-survey-links", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.getContestsEditionSurveyLinks(params);
        },
        ...options,
    }),
    useSurveyResponses: (params, options = {}) => useQuery({
        queryKey: ["contests-edition-survey-responses", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listContestsEditionSurveyResponses(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map